import VideoConfig from '../Configuration/VideoConfig';
import AbstractAsset from './AbstractAsset';

export default class Video extends AbstractAsset {
  protected configuration!: VideoConfig;

  public isBanner(): boolean {
    return false;
  }

  public shouldShowFrame() {
    const targetRatio = 540 / 960;

    if (this.config().get('frame') === false) {
      return false;
    }

    return this.width() / this.height() === targetRatio;
  }

  public mimetype(): string {
    return this.resource.mimetype;
  }

  public config(): VideoConfig {
    if (this.configuration) {
      return this.configuration;
    }

    return (this.configuration = new VideoConfig(
      this.resource.config || {},
      this.directory().config()
    ));
  }
}
